/**
 * UI-6b Task 13 — RecentRecordings config editor.
 *
 * Admin picks how many rows to show. Clamped 1-20 by the Renderer, but the
 * editor enforces the same range at the InputNumber level so the user
 * doesn't see a value that gets silently clamped on render.
 */
import type { JSX } from 'react'
import { InputNumber } from 'primereact/inputnumber'
import type { RecentRecordingsConfig } from './Renderer.js'

interface Props {
  config: RecentRecordingsConfig
  onChange: (next: RecentRecordingsConfig) => void
}

export function RecentRecordingsConfigEditor({
  config,
  onChange,
}: Props): JSX.Element {
  return (
    <div className="flex flex-col gap-3" data-testid="recent-recordings-config-editor">
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Row count</span>
        <InputNumber
          value={config.limit}
          onValueChange={(e): void => onChange({ ...config, limit: e.value ?? 5 })}
          min={1}
          max={20}
          aria-label="Row count"
        />
      </label>
    </div>
  )
}
